export enum MerchantStatusEnum {
  VALID = 'VALID',
  INIT = 'INIT',
  UNKNOWN = 'UNKNOWN',
  EMAIL_MIGRATION = 'EMAIL_MIGRATION',
}
